import {
  GoAButton,
  GoAContainer,
  GoAContainerAccent,
  GoADivider,
  GoASpacer,
} from "@abgov/react-components";
import { useNavigate } from "react-router-dom";
import { InitialPointOfImpact } from "../../models/initial-point-of-impact";
import { get } from "lodash";

interface PointOfImpactProps {
  id: number;
  order: number;
  isInitalPointOfImpact: boolean;
  showEditButton?: boolean;
  showRemoveButton?: boolean;
  helperText?: string;
  initialPointsOfImpact: InitialPointOfImpact[];
  removeHandler: (id: number) => void;
  navigateHandler?: (component: string) => void;
  attachmentDetails?: {
    type: string;
    load: boolean;
    spilled: boolean;
  } | null;
}

export const DamageCardComponent = ({
  id,
  order,
  isInitalPointOfImpact,
  initialPointsOfImpact,
  showEditButton = true,
  showRemoveButton = true,
  helperText = "",
  removeHandler,
  navigateHandler,
  attachmentDetails = null,
}: PointOfImpactProps) => {
  let navigate = useNavigate();

  const pointOfImpact = initialPointsOfImpact.find((x) => x.id === id);

  const getAccent = (isInitalPointOfImpact: boolean): GoAContainerAccent => {
    return isInitalPointOfImpact ? "thin" : "filled";
  };

  const getCircleClassName = (isInitalPointOfImpact: boolean) => {
    return isInitalPointOfImpact
      ? "circle-base circle-initial"
      : "circle-base circle";
  };

  return (
    <div className="damage-container">
      <GoAContainer
        testId={`damage-card-${pointOfImpact?.description
          .toLowerCase()
          .replace(/\s+/g, "")}`}
        accent={getAccent(isInitalPointOfImpact)}
        type="interactive"
      >
        <div className="damage-info">
          <div style={{ display: order > 0 ? "block" : "none" }}>
            <div className={getCircleClassName(isInitalPointOfImpact)}>
              <span className="number">{order}</span>
            </div>
          </div>
          <div>
            <div className="poi-text">
              <div>
                {pointOfImpact && pointOfImpact.getDamageVerbiage().label}
              </div>
              <div className="helper-text">
                {" "}
                {isInitalPointOfImpact &&
                  "You indicated this as your first point of damage"}
              </div>
              <GoASpacer vSpacing="l" />
            </div>
          </div>
        </div>
        <div style={{ display: attachmentDetails ? "block" : "none" }}>
          <GoADivider />
        </div>
        <div style={{ marginLeft: "33px" }}>
          <div style={{ display: attachmentDetails ? "block" : "none" }}>
            <GoASpacer vSpacing="m" />
            <div className="helper-text">
              Attachment load details
              <ul className="enhanced-square-list">
                <li>{attachmentDetails?.type}</li>
                <li>
                  {attachmentDetails?.load
                    ? "Containing load"
                    : "Not containing load"}
                </li>
                <div
                  style={{
                    display: attachmentDetails?.load ? "block" : "none",
                  }}
                >
                  <li>
                    {attachmentDetails?.spilled
                      ? "Load spilled"
                      : "Load not spilled"}
                  </li>
                </div>
              </ul>
            </div>
          </div>

          {isInitalPointOfImpact && (
            <div
              style={{
                display: showEditButton ? "block" : "none",
              }}
            >
              <a
                href="#initial-point-of-impact"
                onClick={() => {
                  if (navigateHandler) navigateHandler("home");
                }}
              >
                Edit
              </a>
            </div>
          )}
          {!isInitalPointOfImpact && (
            <div
              style={{
                display: showRemoveButton ? "block" : "none",
              }}
            >
              <a
                onClick={() => {
                  removeHandler(id);
                }}
              >
                Remove
              </a>
            </div>
          )}
        </div>
      </GoAContainer>
    </div>
  );
};
